module.exports = __webpack_public_path__ + "assets/fleet-of-vehicles.8589b8d9.svg";